import type { AxiosError, AxiosRequestConfig } from 'axios'
import { initAxios, showErrorMessage } from '@meishi/shared'
import Axios from 'axios'
import router from '@/router'
import store from '@/store'
import { UPDATE_ME } from '@/store/types'
import { STORAGE_PERSON_ID } from '@/utils/constants'

const COMMON_ERROR_MESSAGE = '查询失败'
const NET_CODE_401_ERROR_MSG = '没有权限, 请重新登录'

function errorAlert(config: AxiosRequestConfig, msg: string) {
  if (config?.ignoreError) {
    return
  }
  showErrorMessage(msg)
}

function axiosErrorHandler(err: AxiosError, defaultMsg = COMMON_ERROR_MESSAGE): void {
  if (err.response == null) {
    errorAlert(err.config, defaultMsg)
    return
  }
  if (err.response.status === 401) {
    errorAlert(err.config, NET_CODE_401_ERROR_MSG)
    store.commit(UPDATE_ME, null)
    localStorage.removeItem(STORAGE_PERSON_ID)
    router.replace({ name: 'Login' })
    return
  }
  if (err.response.status === 403) {
    router.replace({
      name: '/',
    })
    return
  }
  let msg = err.response.data
  if (!err.config?.fullError && (!msg || msg.length > 100)) {
    msg = err.response.status === 500 ? '服务器错误' : err.response.status
  }
  errorAlert(err.config, msg)
}

initAxios(process.env.API_BASE_URL!)
Axios.interceptors.response.use(
  response => response,
  async (error: AxiosError) => {
    axiosErrorHandler(error)
    return Promise.reject(error)
  },
)
